import { __decorate as t, __classPrivateFieldGet as e, __classPrivateFieldSet as s } from "tslib";
import { LitElement as i, html as o } from "lit";
import { stylesBase as r, styles1177 as n, styles1177pro as l, stylesInera as p, stylesIneraAdmin as c, stylesIneraLegacy as h, stylesIneraAdminLegacy as u } from "./header-item-styles.js";
import a from "../../styles/global-styles.js";
import { property as d, state as m } from "lit/decorators.js";
import { setClassOnTarget as f } from "../../../utilities/utils.js";
var y, b, g, k, v;
class A extends i {
  constructor() {
    super(...arguments), y.set(this, !1), b.set(this, !1), g.set(this, void 0), k.set(this, !1), v.set(this, "");
  }
  get mobile() {
    return e(this, y, "f");
  }
  set mobile(t) {
    s(this, y, t, "f");
  }
  get separatorleft() {
    return e(this, b, "f");
  }
  set separatorleft(t) {
    s(this, b, t, "f");
  }
  get type() {
    return e(this, g, "f");
  }
  set type(t) {
    s(this, g, t, "f");
  }
  get unresponsive() {
    return e(this, k, "f");
  }
  set unresponsive(t) {
    s(this, k, t, "f");
  }
  get linkId() {
    return e(this, v, "f");
  }
  set linkId(t) {
    s(this, v, t, "f");
  }
  get link() {
    return this.querySelector("a");
  }
  get icon() {
    return this.querySelector(".ids-icon");
  }
  firstUpdated(t) {
    super.firstUpdated(t);
    const e = this.closest("ids-header");
    this.setAttribute("type", e.getAttribute("type")), null !== e.getAttribute("unresponsive") && (this.unresponsive = !0), f(this, "ids-hide-on-m", !this.mobile && !this.unresponsive), this.setupIcon();
  }
  setupIcon() {
    this.icon && (this.icon.setAttribute("slot", "icon"), this.icon.setAttribute("width", "100%"), this.icon.setAttribute("height", "100%"), "1177" === this.type ? this.icon.setAttribute("colorpreset", "2") : "1177-pro" === this.type ? this.icon.setAttribute("colorpreset", "1") : (this.icon.setAttribute("color", "var(--header-item-icon-color)"), this.icon.setAttribute("color2", "var(--header-item-icon-color2)")));
  }
  render() {
    return o`<slot></slot><ids-col class="item" cols="auto"><ids-row class="item-link" align="center"><ids-col alignself="center" cols="auto"><div class="item-link-icon"><slot name="icon"></slot></div></ids-col><ids-col class="item-link-text ${this.unresponsive ? "" : "hide-on-m"}" cols="auto">${this.link?.textContent}</ids-col></ids-row></ids-col>`;
  }
}
y = new WeakMap(), b = new WeakMap(), g = new WeakMap(), k = new WeakMap(), v = new WeakMap(), A.styles = [a, r, n, l, p, c, h, u], t([d({
  type: Boolean
})], A.prototype, "mobile", null), t([d({
  type: Boolean
})], A.prototype, "separatorleft", null), t([d({
  type: String,
  reflect: !0
})], A.prototype, "type", null), t([d({
  type: Boolean,
  reflect: !0
})], A.prototype, "unresponsive", null), t([m()], A.prototype, "linkId", null);
export { A as IDSHeaderItem };